// extracted by mini-css-extract-plugin
export default {"link":"PemmdbVersionsControl_link__yAHsh","acceptDelete":"PemmdbVersionsControl_acceptDelete__swEq0","rejectDelete":"PemmdbVersionsControl_rejectDelete__PAWXr"};